import React from 'react';
import { AlertTriangle, X, Clock } from 'lucide-react';

export default function ExpiringGrantsBanner({ grants, onDismiss }) {
  if (!grants || grants.length === 0) return null;

  const getDaysUntilExpiry = (validUntil) => {
    const now = new Date();
    const expiry = new Date(validUntil);
    return Math.ceil((expiry - now) / (1000 * 60 * 60 * 24));
  };

  const getUrgencyClass = (days) => {
    if (days <= 7) return 'bg-red-900/30 border-red-500';
    if (days <= 30) return 'bg-orange-900/30 border-orange-500';
    return 'bg-yellow-900/30 border-yellow-500';
  };

  const getUrgencyIcon = (days) => {
    if (days <= 7) return 'text-red-500';
    if (days <= 30) return 'text-orange-500';
    return 'text-yellow-500';
  };

  return (
    <div className="space-y-3">
      {grants.map(grant => {
        const days = getDaysUntilExpiry(grant.valid_until);
        return (
          <div
            key={grant.id}
            className={`rounded-lg border p-4 ${getUrgencyClass(days)}`}
          >
            <div className="flex items-start justify-between">
              <div className="flex items-start">
                {days <= 7 ? (
                  <AlertTriangle className={`w-5 h-5 ${getUrgencyIcon(days)} mr-3 mt-0.5 flex-shrink-0`} />
                ) : (
                  <Clock className={`w-5 h-5 ${getUrgencyIcon(days)} mr-3 mt-0.5 flex-shrink-0`} />
                )}
                <div>
                  <p className="font-medium">
                    {days <= 7 ? 'Urgent: ' : ''}License Expiring
                    {days <= 0 ? ' Today' : ` in ${days} day${days !== 1 ? 's' : ''}`}
                  </p>
                  <p className="text-sm text-gray-300 mt-1">
                    <span className="font-medium">{grant.customer_name || 'Customer'}</span>
                    {' - '}
                    <span>{grant.product_name || 'Product'}</span>
                    <span className="text-gray-400 ml-2">
                      (expires {new Date(grant.valid_until).toLocaleDateString()})
                    </span>
                  </p>
                </div>
              </div>
              <button
                onClick={() => onDismiss(grant.id)}
                className="text-gray-400 hover:text-white p-1 rounded transition-colors"
                title="Dismiss"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
